module.exports = __webpack_public_path__ + "img/empty.18badf86.png";